import gql from 'graphql-tag';

export default gql`
  query ordersExport($filter: OrderFilterInput, $pagination: Pagination!) {
    ordersExport(pagination: $pagination, filter: $filter) {
      content
    }
  }
`;
